import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from "@fluentui/react";
import { t } from "i18next";
import React from "react";

interface DocumentMasiveDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DocumentMasiveDialog: React.FC<DocumentMasiveDialogProps> = ({ isOpen, onConfirm, onCancel }) => (
  <Dialog
    hidden={!isOpen}
    dialogContentProps={{
      type: DialogType.normal,
    //   title: "¡Ups! Encontramos algo tuyo",
    title: "Exportar Documentos",
    }}
    modalProps={{
      isBlocking: true,
    }}
    onDismiss={onCancel}
  >
    <div>
      {t("Se exportarán todos los documentos cargados para el proyecto / servicio")}
      <br />
    </div>

    <DialogFooter>
      <PrimaryButton onClick={onConfirm} text={t("Continuar")} />
      <DefaultButton onClick={onCancel} text={t("Cancelar")} />
    </DialogFooter>
  </Dialog>
);

export default DocumentMasiveDialog;